(async () => {
    const { Core } = await importModule('Core');
    const ICONS_URL = "https://raw.githubusercontent.com/FortAwesome/Font-Awesome/6.x/svgs/solid/";
    const ICON_PREFIX = 'icon-';
    const CN_ICON = 'icon';

    customElements.define('load-icon', class extends Core {

        async render() {
            if (this.localIcon || await this._loadIcon()) {
                this._displayIcon() 
                this._setIconProps()
                return
            } 
            this._removeContainer();
        }

        async _loadIcon() {
            try {
                const res = await fetch(`${ICONS_URL}/${this.iconName}.svg`);
                if (!res.ok) throw new Error(res.status);
                const svg = await res.text();
                this.localIcon = svg;
                return svg;
            } catch (error) {
                console.error(error.message);
                return null;
            }
        }

        _displayIcon() {
            const svgContent = this.localIcon;
            if (!svgContent) return;
            
            // Safely parse and validate SVG content
            try {
                const parser = new DOMParser();
                const doc = parser.parseFromString(svgContent, 'image/svg+xml');
                
                // Check for parsing errors
                const parserError = doc.querySelector('parsererror');
                if (parserError) {
                    console.warn('Invalid SVG content:', parserError.textContent);
                    return;
                }
                
                // Get the SVG element
                const svgElement = doc.querySelector('svg');
                if (!svgElement) {
                    console.warn('No SVG element found in content');
                    return;
                }
                
                // Validate it's actually an SVG
                if (svgElement.tagName.toLowerCase() !== 'svg') {
                    console.warn('Content is not a valid SVG element');
                    return;
                }
                
                // Remove any potentially dangerous attributes and elements
                this._sanitizeSVG(svgElement);
                
                // Clear current content and append the sanitized SVG
                this.innerHTML = '';
                this.appendChild(svgElement.cloneNode(true));
                
            } catch (error) {
                console.error('Error parsing SVG content:', error);
            }
        }
        
        _sanitizeSVG(svgElement) {
            // List of dangerous attributes that could contain JavaScript
            const dangerousAttributes = [
                'onload', 'onerror', 'onclick', 'onmouseover', 'onmouseout',
                'onfocus', 'onblur', 'onchange', 'onsubmit', 'onreset',
                'onselect', 'onkeydown', 'onkeypress', 'onkeyup',
                'onabort', 'oncanplay', 'oncanplaythrough', 'ondurationchange',
                'onemptied', 'onended', 'onloadeddata', 'onloadedmetadata',
                'onloadstart', 'onpause', 'onplay', 'onplaying', 'onprogress',
                'onratechange', 'onseeked', 'onseeking', 'onstalled', 'onsuspend',
                'ontimeupdate', 'onvolumechange', 'onwaiting'
            ];
            
            // Dangerous elements that shouldn't be in SVG icons
            const dangerousElements = ['script', 'object', 'embed', 'iframe', 'link', 'meta'];
            
            // Remove dangerous elements
            dangerousElements.forEach(tagName => {
                const elements = svgElement.querySelectorAll(tagName);
                elements.forEach(el => el.remove());
            });
            
            // Remove dangerous attributes from all elements
            const allElements = svgElement.querySelectorAll('*');
            allElements.forEach(element => {
                dangerousAttributes.forEach(attr => {
                    if (element.hasAttribute(attr)) {
                        element.removeAttribute(attr);
                    }
                });
                
                // Also check for javascript: URLs in href and other URL attributes
                const urlAttributes = ['href', 'xlink:href', 'src'];
                urlAttributes.forEach(attr => {
                    const value = element.getAttribute(attr);
                    if (value && value.toLowerCase().startsWith('javascript:')) {
                        element.removeAttribute(attr);
                    }
                });
            });
            
            // Remove dangerous attributes from the SVG element itself
            dangerousAttributes.forEach(attr => {
                if (svgElement.hasAttribute(attr)) {
                    svgElement.removeAttribute(attr);
                }
            });
        }
        
        _setIconProps() {
            const $icon = this.querySelector('svg');
            $icon.classList.add(CN_ICON);
            $icon.style.setProperty('--size', this.getAttribute('size'));
        }

        _removeContainer() {
            this.remove();
        }

        get localIcon() {
            return localStorage.getItem(this.localIconName)
        }

        set localIcon(svg) {
            return localStorage.setItem(this.localIconName, svg)
        }
        
        get iconName() {
            return this.getAttribute('name')
        }

        get localIconName() {
            return `${ICON_PREFIX}${this.iconName}`
        }
    })
})();